import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import AdminLayout from "./components/AdminLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./pages/dashboard";
import AdminBooks from "./pages/books";
import AdminOrders from "./pages/orders";
import AdminUsers from "./pages/users";
import TransactionsList from "./pages/transactions/TransactionsList";
import ParcelsList from './pages/parcels';

const BooksList = lazy(() => import('./pages/books'));
const OrdersList = lazy(() => import('./pages/orders/OrdersList'));
const UsersList = lazy(() => import('./pages/users/UsersList'));
const Login = lazy(() => import('./pages/auth/AdminLogin'));
const AddBook = lazy(() => import('./pages/books/add'));
const EditBook = lazy(() => import('./pages/books/edit'));

export const adminRoutes = [
    {
        path: '/admin',
        element: <Navigate to="/admin/dashboard" replace />
    },
    {
        path: '/admin/login',
        element: <Login />
    },
    {
        path: "/admin",
        element: <ProtectedRoute><AdminLayout /></ProtectedRoute>,
        children: [
            {
                path: "dashboard",
                element: <Dashboard />
            },
            {
                path: "books",
                element: <BooksList />
            },
            {
                path: "books/add",
                element: <AddBook />
            },
            {
                path: "books/:id/edit",
                element: <EditBook />
            },
            {
                path: "orders",
                element: <OrdersList />
            },
            {
                path: "users",
                element: <UsersList />
            },
            {
                path: "transactions",
                element: <TransactionsList />
            },
            {
                path: "parcels",
                element: <ParcelsList />
            }
        ]
    }
];

export default adminRoutes; 